export { default } from './TaggisLogo';



// WEBPACK FOOTER //
// ./src/components/atoms/TaggisLogo/index.js